import { Autocomplete, Stack, TextField } from "@mui/material";

import { CalculationParameterResponse } from "@/api";
import { useTranslation } from "@/translations";

interface Props {
  parameters: CalculationParameterResponse[];
  selectedParameter: CalculationParameterResponse | null;
  onSelect: (parameter: CalculationParameterResponse | null) => void;
}

export function ParameterSelect({ parameters, selectedParameter, onSelect }: Props) {
  const { t } = useTranslation();

  return (
    <Stack gap={1}>
      <Autocomplete
        value={selectedParameter}
        onChange={(_, newValue) => onSelect(newValue)}
        options={parameters}
        size="small"
        getOptionLabel={(option) => t(`settings.parameters.names.${option.key}`)}
        isOptionEqualToValue={(option, value) => option.key === value.key}
        fullWidth
        renderInput={(params) => <TextField {...params} label={t("settings.parameters.selectParameter")} />}
      />
    </Stack>
  );
}
